import { useSelector, useDispatch } from 'react-redux'

import Confirmation from 'components/export/confirmation'

import { confirmationOpenSelector, closeConfirmation } from './slice'

export const InvitationsExportConfirmation = () => {
  const open = useSelector(confirmationOpenSelector)
  const dispatch = useDispatch()

  return open && <Confirmation onConfirm={() => dispatch(closeConfirmation())} />
}
